// ===== Interfaces =====

import {
    ISocialAutomationClaimPreviewResult,
}                                               from '../interfaces';

// ===== Enums =====

import {
    SOCIAL_AUTOMATION_CLAIM_PREVIEW_STATUS,
}                                               from '../enums';

const DEFAULT_AUTOMATIONS_PUBLIC_API_BASE_URL = 'https://verascope-automations.web.app/api';

/**
 * Loads the public claim-preview payload from the automations service so the
 * website can render the AuthActionView without exposing any private admin API.
 */
const getSocialAutomationClaimPreview = async ({
    claimLookupToken,
    claimToken,
    platform,
}: {
    claimLookupToken?: string,
    claimToken?: string,
    platform?: string,
}): Promise<ISocialAutomationClaimPreviewResult> => {
    const baseUrl = (
        process.env.REACT_APP_AUTOMATIONS_PUBLIC_API_BASE_URL
        || DEFAULT_AUTOMATIONS_PUBLIC_API_BASE_URL
    ).trim().replace(/\/+$/, '');
    const previewUrl = new URL(`${baseUrl}/claims/preview`);

    if (claimToken) {
        previewUrl.searchParams.set('token', claimToken);
    }
    if (claimLookupToken) {
        previewUrl.searchParams.set('claimLookupToken', claimLookupToken);
    }
    if (platform) {
        previewUrl.searchParams.set('platform', platform);
    }

    try {
        const response = await fetch(previewUrl.toString(), {
            credentials: 'omit',
            method: 'GET',
        });

        if (!response.ok) {
            return {
                status: SOCIAL_AUTOMATION_CLAIM_PREVIEW_STATUS.notFound,
            };
        }

        return await response.json() as ISocialAutomationClaimPreviewResult;
    } catch (_error) {
        return {
            status: SOCIAL_AUTOMATION_CLAIM_PREVIEW_STATUS.notFound,
        };
    }
};

export default getSocialAutomationClaimPreview;
